/**
 * User-friendly auth error messages (Polish)
 * Maps raw error messages to display-ready strings
 */
export function getAuthErrorMessage(rawError) {
  if (!rawError || typeof rawError !== 'string') return rawError;

  const msg = rawError.toLowerCase();

  if (msg.includes('timed out') || msg.includes('timeout')) {
    return 'Połączenie z serwerem trwa zbyt długo. Sprawdź swoje połączenie internetowe i spróbuj ponownie.';
  }
  if (msg.includes('invalid login credentials') || msg.includes('invalid credentials')) {
    return 'Nieprawidłowe dane logowania';
  }
  if (msg.includes('banned') || msg.includes('zablokowane')) {
    return 'Konto użytkownika jest zablokowane.';
  }
  if (msg.includes('401') || msg.includes('jwt') || msg.includes('unauthorized')) {
    return 'Sesja wygasła. Zaloguj się ponownie.';
  }
  if (msg.includes('403') || msg.includes('forbidden')) {
    return 'Brak dostępu. Spróbuj zalogować się ponownie.';
  }
  if (msg.includes('network') || msg.includes('fetch')) {
    return 'Błąd połączenia. Sprawdź internet i spróbuj ponownie.';
  }

  return rawError;
}
